import { Message } from 'lib/apiClient'

export type StackMessage = Message & { debug?: boolean }

export enum MessageGroupType {
  Date = 'date',
  Stack = 'stack',
}

export type MessageGroupDate = {
  type: MessageGroupType.Date
  timestamp: string
}

export type MessageGroupStack = {
  type: MessageGroupType.Stack
  messages: StackMessage[]
}

export type MessageGroup = MessageGroupDate | MessageGroupStack
